export const roundToOne = (num: number): number => {
  return Math.round(num * 10) / 10;
};
